import React, {useContext} from 'react';
import {Container, Row, Col, Spinner, Accordion} from 'react-bootstrap';
import axios from "axios";
import { AppContext } from '../App';


export const Enquiry=()=>{
	const { link, accessToken, setAccessToken, enquiry, setEnquiry, getEnquiryLoad } = useContext(AppContext);
	const changeStatus=(id,status)=>{
		if (!status) {
			axios.post(`${link}api/ss/update/contact/request/`,{
	    			c_id:id.substring(1),
	    			status:true,
	    		},{
	            headers:{
	            	Authorization: 'Bearer '+accessToken
	            }
	          }).then((response)=>{
	            setEnquiry(response.data);
	          }).catch((err)=>{
	            if(err.response.status === 401){
	                setAccessToken();
	            }else if(err.response.status === 404){
	                console.log('Update_contact_request - ',err.response.status,':',err.response.statusText);
	            }else if(err.response.status === 500){
	                console.log('Update_contact_request - ',err.response.status,':',err.response.statusText);
	            }else{
	                console.log('Update_contact_request - ',err.response.status,':',err.response.data);
	            }
	      	});
		}
	}
	return(
		<Container className="py-3">
			<Col  xs={12} sm={12} md={12} lg={12} className='bdr2 br-3 mb-3' >
				<Col xs="12" sm="12" md="12" lg="12" className="staff-type-header bgs1 d-grid p-2 bdrb2" >
					<span>{getEnquiryLoad?(<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>):'Enquiries.'}</span>
				</Col>
			</Col>
			<Col>
				{
					enquiry!==undefined?(
						Object.keys(enquiry).length>0?(
							Object.keys(enquiry).map((enq,e_i)=>(
								<Accordion onClick={()=>{
									changeStatus(enq, enquiry[enq].status);
								}}  key={`enq_${e_i}`} >
							      <Accordion.Item eventKey="0">
							        <Accordion.Header><span className={enquiry[enq].status?'ts2 f18':'tp1 f18'} >{enquiry[enq].username} [ {enquiry[enq].created_date} ]</span></Accordion.Header>
							        <Accordion.Body>
							        
										  <Row className="mb-3" >
									          <Col xs={12} sm={6} md={3} lg={2} >
									    		<span className="ts1">Name</span>
									          </Col>
									          <Col xs={12} sm={6} md={9} lg={10} >
									    		<span className="ts1">{enquiry[enq].name}</span>
									          </Col>
								          </Row>
								          <Row className="mb-3" >
									          <Col xs={12} sm={6} md={3} lg={2} >
									    		<span className="ts1">Phone</span>
									          </Col>
									          <Col xs={12} sm={6} md={9} lg={10} >
									    		<span className="ts1">{enquiry[enq].phone}</span>
									          </Col>
								          </Row>
								          <Row className="mb-3" >
									          <Col xs={12} sm={6} md={3} lg={2} >
									    		<span className="ts1">Query</span>
									          </Col>
									          <Col xs={12} sm={6} md={9} lg={10} >
									    		<span className="p-multi-line ts1" >{enquiry[enq].query}</span>
									          </Col>
								          </Row>
								        
							        </Accordion.Body>
							      </Accordion.Item>
							    </Accordion>
							))
						):'Nothing new!'
					):'Fetching data...'
				}
			</Col>
		</Container>
		)
}
